import { Plan } from "types/graphql";
import { client } from "../gqlClient";
import {
  GET_PLANS,
  GET_PLAN,
  ASSIGN_COUNTRY_TO_PLAN,
  UPDATE_PLAN_SETTINGS,
  REMOVE_COUNTRY_FROM_PLAN,
} from "./schema";
import {
  convertAdminPgToGraphqlRelayPg,
  convertAdminSortToGraphqlSort,
} from "../utils";

export async function getListPlans(params: any): Promise<{
  data: Plan[];
  total: number;
}> {
  const { plans } = await client.query(
    GET_PLANS,
    {
      filter: {
        name: params.filter?.name || null,
        providerId: params.filter?.providerId || null,
        countryIsoCode: params.filter?.countryIsoCode || null,
        providerName: params.filter?.providerName || null,
        platform: params.filter?.platform || null,
        accessType: params.filter?.accessType || null,
        billingPeriodUnit: params.filter?.billingPeriodUnit || null,
        isDisplayed: params.filter?.isDisplayed || null,
      },
      pagination: convertAdminPgToGraphqlRelayPg(params.pagination),
      sort: convertAdminSortToGraphqlSort(params.sort),
    },
    null,
    "network-only"
  );

  return {
    data: plans.edges.map((edge: any) => edge.node),
    total: plans.totalCount,
  };
}

export async function getOnePlan(params: {
  id: string;
}): Promise<{ data: Plan }> {
  const { id } = params;
  const plan = await client.query(GET_PLAN, { id }, "planById");

  return {
    data: plan,
  };
}

export async function updatePlan(params: {
  id: string;
  data: any;
}): Promise<{ data: Plan }> {
  const { id, data } = params;
  const plan = await client.mutate(
    UPDATE_PLAN_SETTINGS,
    {
      id,
      input: {
        accessType: data.accessType,
        isDisplayed: data.isDisplayed,
      },
    },
    "adminPlanUpdateSettings"
  );

  return {
    data: plan,
  };
}

export async function assignCountryToPlan(
  planId: string,
  countryIsoCode: string
): Promise<{ data: Plan }> {
  const plan = await client.mutate(
    ASSIGN_COUNTRY_TO_PLAN,
    {
      input: {
        planId,
        countryIsoCode,
      },
    },
    "adminPlanAssignCountry"
  );

  return {
    data: plan,
  };
}

export async function removeCountryFromPlan(
  planId: string,
  countryIsoCode: string
): Promise<{ data: Plan }> {
  const plan = await client.mutate(
    REMOVE_COUNTRY_FROM_PLAN,
    {
      input: {
        planId,
        countryIsoCode,
      },
    },
    "adminPlanRemoveCountry"
  );

  return {
    data: plan,
  };
}
